module.exports = __webpack_public_path__ + "static/media/linkedin.22aadc31.svg";